/// <reference types="webpack/module" />
import { SharedModule } from './types';

const sharedScope = 'default';

/**
 * Makes sure the script located at `url` is loaded into the document. Then it
 * makes sure it's initialized, which means that it's inserted into Webpack`s
 * module graph.
 */
export const getOrLoadRemote = (
  /**
   * This should be the same as the 'name' property that is set in the client
   * ModuleFederation plugin.
   */
  remote: string,

  /** The URL of the remoteEntry.js file to load */
  url: string,
): Promise<void> =>
  new Promise((resolve, reject) => {
    // check if remote exists on window
    if (global[remote]) {
      // remote already instantiated, resolve
      resolve();
      return;
    }

    // search dom to see if remote tag exists, but might still be loading (async)
    const existingRemote: HTMLScriptElement | null = document.querySelector(
      `[data-webpack="${remote}"]`,
    );

    // when remote is loaded..
    const onload = async () => {
      const remoteModule: SharedModule = global[remote];

      // check if it was initialized
      if (!remoteModule.__initialized) {
        const webpackScopes = __webpack_share_scopes__;
        const scope = webpackScopes[sharedScope];

        // init shared scope
        await remoteModule.init(scope);
        // mark remote as initialized
        remoteModule.__initialized = true;
      }
      // resolve promise so marking remote as loaded
      resolve();
    };

    if (existingRemote) {
      // if existing remote but not loaded, hook into its onload and wait for it to be ready
      existingRemote.onload = onload;
      existingRemote.onerror = reject;
    } else {
      // inject remote if a fallback exists and call the same onload function
      const script = document.createElement('script');
      script.type = 'text/javascript';
      // mark as data-webpack so runtime can track it internally
      script.setAttribute('data-webpack', `${remote}`);
      script.async = true;
      script.onerror = reject;
      script.onload = onload;
      script.src = url;
      document.getElementsByTagName('head')[0].appendChild(script);
    }
  });
